import { render, staticRenderFns } from "./partners-modal.vue?vue&type=template&id=563e751e"
import script from "./partners-modal.vue?vue&type=script&lang=js"
export * from "./partners-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports